export default __webpack_public_path__ + "static/media/resetIcon.b7cafc6c.svg";